import { render, staticRenderFns } from "./DeudaImportPage.vue?vue&type=template&id=ffaae9ec&scoped=true"
import script from "./DeudaImportPage.vue?vue&type=script&lang=js"
export * from "./DeudaImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaae9ec",
  null
  
)

export default component.exports